export default {
  observability: {
    expectedErrors: [],
  },
};
